import React, {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer, RaikoGridOneColumn,
    RaikoSectionContainer, RaikoToggleOutlined,
    showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {ProductVariantService} from "../../../serverService/productVariantService/ProductVariantService";

export default function ProductVariantDefault({variantId}) {

    const [defaultState, setDefaultState] = useState(false);
    const [actionButtonLoading, setActionButtonLoading] = useState(false)
    const loading = new LoadingHelper(useLoadingDispatcher());
    const service = new ProductVariantService();

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getProductVariantDefault()
        }
    }, [variantId]);


    function getProductVariantDefault() {
        loading.show()
        service.getProductVariantDefault(variantId)
            .then(response => {
                setDefaultState(response.default)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateProductVariantDefault() {
        setActionButtonLoading(true);
        service.updateProductVariantDefault(variantId, defaultState)
            .then(response => {
                if (defaultState)
                    showSuccessMessage("نوع محصول به عنوان پیش فرض قرار داده شد.")
                else
                    showWarningMessage("نوع محصول از حالت پیش فرض خارج شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت پیش فرض"}
                    subTitle={"قرار دادن نوع محصول به عنوان پیش فرض"}
                    hasActionButton
                    actionButtonLoadingState={actionButtonLoading}
                    actionButtonOnclick={handleUpdateProductVariantDefault}
                >
                    <RaikoGridOneColumn>
                        <RaikoToggleOutlined
                            checked={defaultState}
                            setChecked={setDefaultState}
                            labelText={"پیش فرض /  پیش نویس"}
                        />
                    </RaikoGridOneColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

        </>
    )
}